import Webp from './Webp'

export default Webp
